import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function Terms() {
  return <div className="w-full min-h-screen bg-slate-50" data-id="element-298">
      <div className="max-w-4xl mx-auto px-6 py-12" data-id="element-299">
        <Link to="/" className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-8 font-medium" data-id="element-300">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-301" />
          Back to Home
        </Link>
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12" data-id="element-302">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8" data-id="element-303">
            Customer Terms and Conditions
          </h1>
          <div className="prose prose-slate max-w-none space-y-8" data-id="element-304">
            <section data-id="element-305">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-306">
                About Us
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-307">
                Pomelo Services Ltd ("us", "we", "our") is a limited liability
                company registered in England and Wales, number 13810984. Our
                registered office address is 128 City Road, London, United
                Kingdom, EC1V 2NX.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-308">
                Enhanced Payment Protection ("EPP") is a product offered by
                Pomelo Services that gives cardholders extra protection when
                cardholders pay Customers. The aim of the product is to provide
                cardholders multi-layer protection when they checkout on portals
                and securely use the same card to make multiple purchases to the
                same Customers where applicable.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-309">
                Customers are purchasing the Goods/Services from Pomelo Services
                only. Customers can refer to us for details of any terms or
                conditions applying to this purchase, including their statutory
                right to cancellation and a refund.
              </p>
              <p className="text-slate-700 leading-relaxed" data-id="element-310">
                To contact us, you can message our support team at{' '}
                <a href="mailto:info@pomeloservices.uk" className="text-blue-600 hover:text-blue-700" data-id="element-311">
                  info@pomeloservices.uk
                </a>
                .
              </p>
            </section>
            <section data-id="element-312">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-313">
                1. The Customer Terms and Conditions
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-314">
                The Customer Terms and Conditions comprise:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-315">
                <li data-id="element-316">these terms and conditions; and</li>
                <li data-id="element-317">any other schedules that are added.</li>
              </ul>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-318">
                By agreeing to the Customer Terms and Conditions, you are bound
                by them in their entirety. If you do not agree to them, you must
                not complete a payment with us. Once you have selected EPP and
                complete the payment you are bound to these terms and
                conditions. If you refuse to accept you must notify us
                immediately within two hours of your purchase where we will
                immediately refund your payment and you will need to make
                another payment without the EPP.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-319">
                References in these terms and conditions to "you" and "your" are
                to you in your capacity as a Customer. Capitalised terms are
                defined in Paragraph 15. The Customer Terms and Conditions are
                made only in the English language.
              </p>
              <p className="text-slate-700 leading-relaxed" data-id="element-320">
                The Customer Terms and Conditions were last updated on 05 April
                2022
              </p>
            </section>
            <section data-id="element-321">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-322">
                2. Amendments to the Customer Terms and Conditions
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-323">
                We expect to need to update or amend the Customer Terms and
                Conditions from time to time to:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-324">
                <li data-id="element-325">comply with law or regulations; or</li>
                <li data-id="element-326">meet our changing business requirements.</li>
              </ul>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-327">
                We may make such changes without your specific agreement, but
                only where those updates are required to comply with law or
                regulations or are of an immaterial and routine nature. We will
                give you prior notice of such updates or amendments.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-328">
                We may also need to update or amend the Customer Terms and
                Conditions for other reasons, including in order to:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-329">
                <li data-id="element-330">introduce Add-on Services;</li>
                <li data-id="element-331">
                  change the pricing basis for the services we provide to you;
                </li>
                <li data-id="element-332">
                  change the structure, features or other terms of the services
                  we provide to you,
                </li>
              </ul>
              <p className="text-slate-700 leading-relaxed" data-id="element-333">
                If you accept the Customer Terms and Conditions, the updated
                Customer Terms and Conditions will govern our relations from the
                date of acceptance.
              </p>
            </section>
            <section data-id="element-334">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-335">
                3. How to Become a Customer
              </h2>
              <p className="text-slate-700 leading-relaxed" data-id="element-336">
                In order to become a Customer, you must select via the toggle on
                a payment portal to pay your transaction via EPP. You are solely
                responsible for ensuring that the information provided by you
                during this process is complete and accurate. Once payment is
                accepted, you will be bound by the Customer Terms and Conditions
                where we begin providing the Services to you, at which point a
                contract will be formed between us (our "Contract").
              </p>
            </section>
            <section data-id="element-337">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-338">
                4. Services
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-339">
                We offer the three services set out in Paragraphs 5.2 to 5.4
                (the "Services"):
              </p>
              <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-340">
                PCI certified payment page
              </h3>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-341">
                <li data-id="element-342">
                  A payment portal that has been externally certified under PCI
                  standards on an annual basis
                </li>
                <li data-id="element-343">
                  This payment portal applies to all payment methods offered on
                  the payment portal
                </li>
              </ul>
              <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-344">
                Latest 3DS version/security
              </h3>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-345">
                <li data-id="element-346">
                  EPP provides cardholders with the latest 3DS protocols which
                  helps cardholders to be fully protected for all transactions
                  that are eligible
                </li>
              </ul>
              <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-347">
                Single Use Card
              </h3>
              <ul className="list-disc pl-6 text-slate-700 space-y-2" data-id="element-348">
                <li data-id="element-349">
                  All transactions that a Customer makes will be loaded onto a
                  single-use virtual Mastercard
                </li>
                <li data-id="element-350">
                  This card will be used to allow our Customers to charge the
                  single use card
                </li>
                <li data-id="element-351">
                  This means the Customer's original payment method is never
                  exposed to the Customer
                </li>
              </ul>
            </section>
            <section data-id="element-352">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-353">
                5. Service Fees
              </h2>
              <ul className="list-disc pl-6 text-slate-700 space-y-2" data-id="element-354">
                <li data-id="element-355">
                  The Service Fees will be added on top of the original payment
                  amount
                </li>
                <li data-id="element-356">
                  The Service Fees are exclusive of amounts in respect of VAT.
                  Any VAT payable will be paid by us
                </li>
              </ul>
            </section>
            <section data-id="element-357">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-358">
                6. Payments, Refunds and Chargebacks
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-359">
                When a Customer selects EPP, Pomelo Services will process the
                Payment and, provided that the Payment is authorised by the
                relevant payments providers. (a "Customer Payment").
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-360">
                Pomelo may suspend the processing of any Transaction where
                Pomelo reasonably believes that the Transaction may be
                fraudulent or involves any criminal activity.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-361">
                In circumstances where the Customer requests a refund on all or
                part of a Payment in connection with a purchase made by a
                Customer, Pomelo Services has the right to request further
                information from the Customer prior to us processing the refund.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-362">
                This may include but not limited to documents relating to source
                of funds, further know-your-customer ("KYC") checks and other
                information relevant to your transaction.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-363">
                Pomelo may refuse to execute a Refund if it does not meet the
                conditions in the Customer Terms and Conditions or is prohibited
                by law. If Pomelo does refuse to execute a Refund, within the
                time for processing the Refund, it will notify the Customer
                (unless prohibited by law) of the refusal and, if possible, the
                reasons for it and the procedure for correcting any factual
                mistakes that led to the refusal. Any Refund that is refused
                will not be deemed to have been received for purposes of
                execution times and liability for non-execution or defective
                execution.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-364">
                In circumstances where the Customer initiates a chargeback, the
                Customer will need to initiate this from the payment provider
                selected
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-365">
                Once Pomelo Services receives the chargeback requests, Pomelo
                Services will respond to the payment provider directly regarding
                the chargeback within the given timeframe.
              </p>
              <p className="text-slate-700 leading-relaxed" data-id="element-366">
                For the avoidance of doubt, in the event of a chargeback, Pomelo
                Services will not have direct communication with the Customer.
              </p>
            </section>
            <section data-id="element-367">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-368">
                7. Customer Support and Complaints
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-369">
                Once you purchases EPP, you will become a Customer of us and we
                will handle all customer support, disputes and complaints with
                you directly.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-370">
                For the avoidance of doubt, any goods or services purchased
                relating to the EPP will be handled by Pomelo Services directly
                with the Merchant.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-371">
                You shall provide us with all reasonable assistance in providing
                us with details of your complaint made by you against the
                Customer in connection with the Services ("Complaint"),
                including:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-372">
                <li data-id="element-373">
                  notifying us in writing as soon as practicable of the
                  Complaint;
                </li>
                <li data-id="element-374">
                  allowing us to conduct all negotiations and proceedings;
                </li>
                <li data-id="element-375">
                  providing us with such reasonable assistance and information
                  as is required by us from time to time regarding the
                  Complaint;
                </li>
                <li data-id="element-376">
                  taking all reasonable steps to preserve all documentary
                  evidence which may be required in any proceedings related to
                  the Complaint; and
                </li>
                <li data-id="element-377">
                  not, without our prior written consent, making any admission
                  relating to the Complaint or attempting to settle it.
                </li>
              </ul>
              <p className="text-slate-700 leading-relaxed" data-id="element-378">
                For the avoidance of doubt, Pomelo Services are solely
                responsible for resolving all claims, disputes or complaints
                relating to the Goods/Services and the Sales Agreement,
                including disputes relating to the delivery or non-delivery of
                such Goods/Services (each, a "Dispute") and shall use all
                reasonable endeavours to resolve (to our reasonable
                satisfaction) all such Disputes within 30 calendar days.
              </p>
            </section>
            <section data-id="element-379">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-380">
                8. Data Protection
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-381">
                Each party undertakes that it will comply, and will cause its
                employees, agents and subcontractors to comply, with Data
                Protection Laws in connection with the performance of its
                obligations under the Customer Terms and Conditions.
              </p>
              <p className="text-slate-700 leading-relaxed" data-id="element-382">
                You agree to indemnify and keep indemnified and defend at your
                own expense us against all costs, claims, damages or expenses
                incurred by us or for which we may become liable due to any
                failure by you or your Agents to comply with any of its
                obligations under this Paragraph 15.
              </p>
            </section>
            <section data-id="element-383">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-384">
                9. Confidentiality
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-385">
                Each Party (the "receiving party") undertakes that it shall not
                at any time disclose to any person any Confidential Information
                of the other party (and in the case of the Customer as a
                receiving party, any Confidential Information of our Agents)
                ("disclosing party") except that the receiving party may
                disclose the disclosing party's Confidential Information to:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-386">
                <li data-id="element-387">
                  its employees, officers, representatives, or advisors who need
                  to know such information for the purposes of carrying out the
                  obligations or exercising the rights of the receiving party
                  under this Contract, provided that the receiving party shall
                  procure that its employees, officers, representatives and
                  advisors to whom it discloses the disclosing party's
                  Confidential Information comply with this Paragraph 10; and
                </li>
                <li data-id="element-388">
                  as may be required by law, a court of competent jurisdiction
                  or any Regulatory Body.
                </li>
              </ul>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-389">
                The receiving party shall not use the disclosing party's
                Confidential Information other than as is required for the
                purposes of carrying out the obligations or exercising the
                rights of the receiving party under the Customer Terms and
                Conditions.
              </p>
              <p className="text-slate-700 leading-relaxed" data-id="element-390">
                On expiry or termination for any reason of the Customer Terms
                and Conditions, the receiving party shall return to the
                disclosing party (or, at the disclosing party's option,
                permanently delete and destroy) all documents and materials
                (including any copies thereat) containing, reflecting,
                incorporating or based on the disclosing party's Confidential
                Information, provided that the receiving party may retain such
                copies of such documents and materials to the extent required by
                Applicable Law or a Regulatory Body.
              </p>
            </section>
            <section data-id="element-391">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-392">
                10. Force Majeure
              </h2>
              <p className="text-slate-700 leading-relaxed" data-id="element-393">
                Neither Pomelo Services nor our suppliers shall be liable for a
                breach of this Agreement directly or indirectly caused by
                circumstances beyond its reasonable control including but not
                limited to any natural disaster, war, terrorist attack or
                similar actions, non-performance by suppliers or sub-contractors
                (including our suppliers), and interruption or failure of any
                utility service.
              </p>
            </section>
            <section data-id="element-394">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-395">
                11. Notices
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-396">
                Any written notice may be delivered in person, by email or sent
                by first-class post to The Directors, Pomelo Services at Kemp
                House, 160 City Road, London, United Kingdom, EC1V 2NX.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-397">
                Notices by post shall be deemed duly given forty eight (48)
                hours after posting by first class post or seventy two (72)
                hours if sent by airmail. Notices by email shall be deemed duly
                given when delivered.
              </p>
              <p className="text-slate-700 leading-relaxed" data-id="element-398">
                You agree that we may act on email notices or instructions that
                reasonably appear to emanate from you or your Agent.
              </p>
            </section>
            <section data-id="element-399">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-400">
                12. Other Important Terms
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-401">
                Each Party agrees that it shall, and that it shall procure, that
                persons associated with it (as determined in accordance with
                section 8 of the Bribery Act 2010) shall:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-402">
                <li data-id="element-403">
                  comply with all Applicable Laws relating to bribery and other
                  corruption including the Bribery Act 2010 ("Anti-Corruption
                  Requirements");
                </li>
                <li data-id="element-404">
                  not take or knowingly permit any action to be taken that would
                  or might cause or lead the other Party to be in violation of
                  any Anti-Corruption Requirements including under section 7 of
                  the Bribery Act 2010; and
                </li>
                <li data-id="element-405">
                  not bribe or attempt to bribe (which shall include any offer
                  or form of payment, gift or other inducement, reward or
                  advantage (whether of money or anything of value)) the other
                  Party or their Agents, affiliates or persons acting on their
                  behalf.
                </li>
              </ul>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-406">
                The Customer Terms and Conditions do not constitute, establish
                or imply any partnership, joint venture, agency, employment or
                fiduciary relationship between the Parties. Neither Party shall
                have, nor represent that it has, any authority to make or enter
                into any commitments on the other's behalf or otherwise bind the
                other in any way (including the making of any representation or
                warranty, the assumption of any obligation or liability or the
                exercise of any right or power).
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-407">
                The Customer Terms and Conditions (as varied from time to time
                in accordance with their terms) constitute the entire agreement
                and understanding of the Parties and supersede and extinguish
                all previous drafts, agreements and understandings between them,
                whether oral or in writing, relating to its subject matter. Each
                Party acknowledges and agrees that in entering into the Customer
                Terms and Conditions it does not rely on, and shall have no
                remedies in respect of, any statement, representation,
                assurance, warranty or understanding made by or on behalf of a
                Party (whether made innocently or negligently) which is not
                expressly set out in the Customer Terms and Conditions. Neither
                Party shall have any claim for innocent or negligent
                misrepresentation based upon any statement, representation,
                assurance or warranty in the Customer Terms and Conditions.
                Nothing in the Customer Terms and Conditions shall limit or
                exclude any liability for fraud.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-408">
                If any provision, or part of a provision, of the Customer Terms
                and Conditions is found by any court or administrative body of
                competent jurisdiction to be invalid, illegal or unenforceable
                (a "Void Provision"):
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-409">
                <li data-id="element-410">
                  such invalidity, illegality or unenforceability shall not
                  affect the other provisions of the Customer Terms and
                  Conditions, which shall remain in full force and effect;
                </li>
                <li data-id="element-411">
                  if a Void Provision would be valid, legal and enforceable if
                  some part of it were deleted, that Void Provision shall apply
                  with such modification as may be necessary to make it valid,
                  legal and enforceable;
                </li>
                <li data-id="element-412">
                  if a Void Provision cannot be made valid, legal and
                  enforceable under Paragraph 13.4(a), the Parties shall
                  negotiate in good faith to amend the Void Provision to be
                  valid, legal and enforceable whilst achieving, to the greatest
                  extent possible, the Parties' original commercial intention;
                  and
                </li>
                <li data-id="element-413">
                  if a Void Provision cannot be made valid, legal and
                  enforceable under Paragraph 13.4(a) or 13.4(b), the Void
                  Provision shall be deemed to be deleted.
                </li>
              </ul>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-414">
                No term of the Customer Terms and Conditions shall be
                enforceable under the Contracts (Rights of Third Parties) Act
                1999 by any person who is not a Party to the Customer Terms and
                Conditions save that any PSP and our Agents shall be entitled to
                enforce those Paragraphs of the Customer Terms and Conditions
                which confer a right or benefit on such PSP or our Agents (as
                applicable), provided always that such PSP or our Agents (as
                applicable) shall only be able to rely on this Paragraph 13.5
                where it has suffered a loss of as a result of any breach of any
                such Paragraphs by the Customer. Notwithstanding the foregoing,
                the consent of such PSP or our Agents (as applicable) shall not
                be required for any rescission, variation (including any release
                or compromise in whole or in part of any liability) or
                termination of the Customer Terms and Conditions or of any part
                of them.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-415">
                A failure to exercise, or delay in exercising, a right, power or
                remedy provided by the Customer Terms and Conditions or by law
                does not constitute a waiver of that, or any other, right, power
                or remedy and shall not, and nor shall any single or partial
                exercise of any such right, power or remedy, preclude the
                further exercise of that, or any other, right, power or remedy.
                Any waiver of any right under the Customer Terms and Conditions
                is only effective if it is in writing and it applies only to the
                Party to whom the waiver is addressed and to the circumstances
                for which it is given.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-416">
                You shall not assign, transfer, mortgage, charge, sub-contract
                or deal in any other manner with any or all of its rights and/or
                obligations under the Customer Terms and Conditions without our
                prior written consent (such consent not to be unreasonably
                withheld or delayed).
              </p>
              <p className="text-slate-700 leading-relaxed" data-id="element-417">
                For the avoidance of doubt, nothing in the Customer Terms and
                Conditions shall prevent us from providing similar services to
                those set out in the Customer Terms and Conditions to any other
                person.
              </p>
            </section>
            <section data-id="element-418">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-419">
                13. Governing Law and Jurisdiction
              </h2>
              <p className="text-slate-700 leading-relaxed" data-id="element-420">
                The Contract, the Customer Terms and Conditions and any dispute
                or claim arising out of or in connection with any of them or
                their subject matter or formation (including non-contractual
                disputes and claims) shall be governed by and construed in
                accordance with the law of England and each Party irrevocably
                agrees that the courts of England and Wales shall have exclusive
                jurisdiction to settle any such dispute or claim.
              </p>
            </section>
            <section data-id="element-421">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-422">
                14. Definitions & Interpretation
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-423">
                In the Customer Terms and Conditions the following words and
                expressions shall have the following meanings:
              </p>
              <div className="space-y-3 text-slate-700" data-id="element-424">
                <p data-id="element-425">
                  <strong data-id="element-426">"Affiliate"</strong> means as regards a Party, its
                  ultimate holding company and each of its ultimate holding
                  company's other subsidiaries for the time being;
                </p>
                <p data-id="element-427">
                  <strong data-id="element-428">"Applicable Law"</strong> means all laws, rules,
                  regulations, policies, guidance or industry codes, rules of
                  court or directives or requirements or notice of any
                  Regulatory Body, delegated or subordinate legislation which
                  are relevant and applicable to (i) the performance of a
                  Party's obligations under the Customer Terms and Conditions,
                  including the Act and (ii) in case of the Customer, the Sale
                  Agreements, the supply or provision of Goods/Services and the
                  operation of the Customer's Site;
                </p>
                <p data-id="element-429">
                  <strong data-id="element-430">"Confidential Information"</strong> means any
                  information of a confidential, secret or business nature,
                  including that which concerns a Party's business, affairs,
                  customers, contractors (including in the case of Pomelo) or
                  suppliers and the terms of the Customer Terms and Conditions;
                </p>
                <p data-id="element-431">
                  <strong data-id="element-432">"Control"</strong> has the meaning ascribed to it in
                  section 11.24 of the Corporation Tax Act 2010;
                </p>
                <p data-id="element-433">
                  <strong data-id="element-434">"Customer"</strong> means a person introduced by the
                  Customer who has made, or who wishes to make, a payment for
                  Goods/Services via the Platform;
                </p>
                <p data-id="element-435">
                  <strong data-id="element-436">"Data Protection Laws"</strong> means any applicable
                  law relating to the processing, privacy, and use of Personal
                  Data including (i) the Data Protection Act 2018 and the
                  Privacy and Electronic Communications (EC Directive)
                  Regulations 2003, SI 2003/2426, and any laws or regulations
                  implementing Directive 95/46/EC (Data Protection Directive) or
                  Directive 2002/58/EC (ePrivacy Directive); (ii) the General
                  Data Protection Regulation (EU) 2016/679 (GDPR), and/or any
                  corresponding or equivalent national laws or regulations; and
                  (iii) any judicial or administrative interpretation of any of
                  the above, any guidance, guidelines, codes of practice,
                  approved codes of conduct or approved certification mechanisms
                  issued by any relevant supervisory authority or regulator
                  having jurisdiction over the Customer.
                </p>
                <p data-id="element-437">
                  <strong data-id="element-438">"Default"</strong> means any breach of the obligations
                  of the relevant Party (including a fundamental breach or
                  breach of a fundamental term) or any other default, act,
                  omission, negligence or statement of the relevant Party, or
                  its Agents in connection with or in relation to the
                  subject-matter of the Customer Terms and Conditions or any
                  Sale Agreement;
                </p>
                <p data-id="element-439">
                  <strong data-id="element-440">"Dispute"</strong> has the meaning given to in
                  Paragraph 8.4;
                </p>
                <p data-id="element-441">
                  <strong data-id="element-442">"Effective Date"</strong> means the date that the
                  Customer Terms and Conditions are entered into by the Parties;
                </p>
                <p data-id="element-443">
                  <strong data-id="element-444">"Goods/Services"</strong> means the products and/or
                  services to be supplied by the Customer to the Customer under
                  the applicable Sale Agreement and which are, or are to be,
                  financed using the Loan Facility;
                </p>
                <p data-id="element-445">
                  <strong data-id="element-446">"Insolvency Event"</strong> means, in respect of a
                  Party, where a) that Party is, or is deemed to be, insolvent
                  or unable (or admits its inability) to pay its debts as they
                  fall due or stops or suspends payment of any of its debts; or
                  b) that Party is unable to pay its debts, or being capable of
                  being deemed unable to pay its debts, within the meaning of
                  section 123 of the Insolvency Act 1986; or c) any
                  expropriation, attachment, sequestration, distress, execution,
                  enforcement of security or other legal process is levied,
                  enforced or sued out on or against, or affects, any of that
                  Party's assets and is not discharged or stayed within twenty
                  one (21) days; or d) that Party begins negotiations, or enters
                  into any composition or arrangement, with one or more of its
                  creditors in order to reschedule any of its indebtedness
                  because of actual or anticipated financial difficulties; or e)
                  a moratorium is declared over any of that Party's
                  indebtedness; or f) any petition is presented, resolution
                  proposed or other action, proceedings, procedure or step taken
                  for, or which may lead to: (i) the suspension of payments,
                  winding up, dissolution, administration or reorganisation
                  (using a voluntary arrangement, scheme of arrangement or
                  otherwise) of that Party; or (ii) the appointment of a
                  liquidator, receiver, administrative receiver, administrator,
                  compulsory manager or other similar officer in respect of that
                  Party or any of its assets; or g) that Party suffers any event
                  similar to any of those set out at a) to f) (inclusive) of
                  this definition including in any jurisdiction to which it is
                  subject; or h) that Party suspends or ceases to carry on (or
                  threatens to suspend or cease to carry on) all or a material
                  part of its business;
                </p>
                <p data-id="element-447">
                  <strong data-id="element-448">"Intellectual Property Rights"</strong> mean any
                  patent, copyright, trade mark, service mark or trade name,
                  utility model, right in software, right in design, right in
                  databases, image right, moral right, right in an invention,
                  right relating to passing off, domain name, right in
                  confidential information (including trade secrets) or right of
                  privacy, and all similar or equivalent rights in each case
                  whether registered or not and including all applications (or
                  rights to apply) for, or renewal or extension of, such rights
                  which exist now or which will exist in the future in the
                  United Kingdom and all other countries in the world;
                </p>
                <p data-id="element-449">
                  <strong data-id="element-450">"Licence"</strong> mean all licences, approvals,
                  authorisations, consents, permissions and/or registrations
                  which are necessary in connection with the exercise of the
                  rights of the Customer and performance of the obligations of
                  the Customer under the Customer Terms and Conditions,
                  including those required by Applicable Law;
                </p>
                <p data-id="element-451">
                  <strong data-id="element-452">"Loss"</strong> means all losses, damages, costs,
                  expenses (including reasonable legal fees) and any other
                  liabilities;
                </p>
                <p data-id="element-453">
                  <strong data-id="element-454">"Parties"</strong> means Pomelo and the Customer
                  collectively, and each shall be a "Party"
                </p>
                <p data-id="element-455">
                  <strong data-id="element-456">"Payment"</strong> means the payment by a Customer to
                  Pomelo Services
                </p>
                <p data-id="element-457">
                  <strong data-id="element-458">"Refund"</strong> means the repayment by the Customer
                  to a Customer of all or part of a Payment made by that
                  Customer where such repayment is made using the Services.
                </p>
                <p data-id="element-459">
                  <strong data-id="element-460">"Service Fees"</strong> means the fees payable by a
                  Customer to Pomelo for the Services as set out in detail in
                  the Service Fees Schedule;
                </p>
                <p data-id="element-461">
                  <strong data-id="element-462">"Service Fees Schedule"</strong> means the schedule to
                  these Customer Terms and Conditions setting out the Service
                  Fees, as may be updated, amended or replaced by Pomelo from
                  time to time;
                </p>
                <p data-id="element-463">
                  <strong data-id="element-464">"Services"</strong> means the services provide by
                  Pomelo set out in Paragraph 4;
                </p>
                <p data-id="element-465">
                  <strong data-id="element-466">"Transaction"</strong> means a Payment or a Refund;
                  and
                </p>
                <p data-id="element-467">
                  <strong data-id="element-468">"Working Day"</strong> means a day (other than a
                  Saturday, a Sunday or a public holiday in England) on which
                  banks in London are open for business.
                </p>
              </div>
              <div className="mt-6 space-y-3 text-slate-700" data-id="element-469">
                <p className="font-semibold" data-id="element-470">
                  In the Customer Terms and Conditions:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-471">
                  <li data-id="element-472">
                    references to Pomelo Services include any of its Affiliates;
                  </li>
                  <li data-id="element-473">
                    references to Paragraphs are to Paragraphs of the Customer
                    Terms and Conditions;
                  </li>
                  <li data-id="element-474">
                    references to a "person" shall be construed to include any
                    individual, firm, company, government, state or agency of
                    the state or any joint venture, association or partnership
                    (whether or not having separate legal personality);
                  </li>
                  <li data-id="element-475">
                    a reference to any statute or statutory provision shall be
                    construed as a reference to the same as it may have been, or
                    may from time to time be, amended, modified or re-enacted;
                  </li>
                  <li data-id="element-476">
                    any words following the terms "including", "include", "in
                    particular" or any similar terms shall be construed as
                    illustrative only and shall not limit the sense of the words
                    preceding those terms;
                  </li>
                  <li data-id="element-477">
                    use of the singular includes the plural and vice versa;
                  </li>
                  <li data-id="element-478">
                    any obligation on a Party not to do something includes an
                    obligation not to allow that thing to be done;
                  </li>
                  <li data-id="element-479">
                    any reference to an English legal term for any action,
                    remedy, method of judicial proceeding, legal document, legal
                    status, court, official or any legal concept or thing shall,
                    in respect of any jurisdiction other than England, be deemed
                    to include a reference to that which most nearly
                    approximates to the English legal terms in that
                    jurisdiction; and
                  </li>
                  <li data-id="element-480">
                    headings to Paragraphs are for convenience only and shall
                    not affect the interpretation of the Customer Terms and
                    Conditions.
                  </li>
                </ul>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer data-id="element-481" />
    </div>;
}